'use client'
import CallUsIcon from '@/assets/icons/call-us.svg'
import EmailIcon from '@/assets/icons/email.svg'
import LocationIcon from '@/assets/icons/location.svg'
import { ROUTES } from '@/core/constants/routes'
import { AppSettingsModel } from '@/features/content/types/models/app-settings.model'
import { use } from 'react'

type Props = {
  appSettingsPromise: Promise<AppSettingsModel | null>
  supportNumberPromise: Promise<string>
}
export const CompanyInfo: React.FC<Props> = ({
  appSettingsPromise,
  supportNumberPromise,
}) => {
  const appSettings = use(appSettingsPromise)
  const supportNumber = use(supportNumberPromise)
  const location = appSettings?.generalInfo.companyLocation
  const email = appSettings?.generalInfo.email
  return (
    <div className='flex flex-col gap-4'>
      {location ? (
        <span className='flex items-center gap-2'>
          <LocationIcon className='fill-primary h-5 w-5' />
          <span>{location}</span>
        </span>
      ) : null}
      {supportNumber ? (
        <span className='flex items-center gap-2'>
          <CallUsIcon className='h-5 w-5' />
          <a
            href={ROUTES.tel(supportNumber)}
            target='_blank'
            rel='noreferrer'
            className='underline hover:no-underline'
          >
            {supportNumber}
          </a>
        </span>
      ) : null}
      {email ? (
        <span className='flex items-center gap-2'>
          <EmailIcon className='fill-primary h-5 w-5' />
          <a
            href={ROUTES.mail(email)}
            target='_blank'
            rel='noreferrer'
            className='underline hover:no-underline'
          >
            {email}
          </a>
        </span>
      ) : null}
    </div>
  )
}
